import React from "react";
import styles from './ResultsPagination.module.scss';
import { scrollToTop } from "../../helpers/Utils";

interface ResultsPaginationProps {
    totalResults: number;
    itemsPerPage: number | "all";
    currentPage: number;
    setCurrentPage: (page: number) => void;
}

const ResultsPagination: React.FC<ResultsPaginationProps> = ({ totalResults, itemsPerPage, currentPage, setCurrentPage }) => {
    const totalPages = itemsPerPage === "all" ? 1 : Math.ceil(totalResults / itemsPerPage);

    const getPageNumbers = () => {
        const pages = [];
        const maxVisiblePages = 5;

        if (totalPages <= maxVisiblePages) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            if (currentPage <= 3) {
                pages.push(1, 2, 3, 4, '...', totalPages);
            } else if (currentPage >= totalPages - 2) {
                pages.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            } else {
                pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
            }
        }

        return pages;
    };

    const handlePageClick = (page: number | string) => {
        if (typeof page === "number") {
            setCurrentPage(page);
            scrollToTop();
        }
    };

    return (
        <React.Fragment>
            <section className={`${styles["results-pagination"]} section`}>
                <div className="container">
                    <nav className="d-flex justify-content-center" aria-label="Page navigation">
                        <ul>
                            <li>
                                {currentPage === 1 ? (
                                    <span
                                        className={`${styles["nav-btn"]} ${styles["disabled"]}`}
                                        aria-label="Previous page"
                                        aria-disabled="true"
                                    >
                                        <i className="bi bi-arrow-left-short"></i>
                                    </span>
                                ) : (
                                    <a
                                        href="#"
                                        className={styles["nav-btn"]}
                                        aria-label="Previous page"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setCurrentPage(currentPage - 1);
                                            scrollToTop();
                                        }}
                                    >
                                        <i className="bi bi-arrow-left-short"></i>
                                    </a>
                                )}
                            </li>
                            {getPageNumbers()?.map((page, index) => (
                                <li key={index} className={page === '...' ? styles["ellipsis"] : undefined}>
                                    {page === '...' ? (
                                        <span aria-hidden="true">...</span>
                                    ) : (
                                        <a
                                            href="#"
                                            className={page === currentPage ? styles["active"] : undefined}
                                                onClick={(e) => {
                                                    e.preventDefault(); handlePageClick(page)
                                                }}
                                        >
                                            {page}
                                        </a>
                                    )}
                                </li>
                            ))}
                            <li>
                                {currentPage === totalPages ? (
                                    <span
                                        className={`${styles["nav-btn"]} ${styles["disabled"]}`}
                                        aria-label="Next page"
                                        aria-disabled="true"
                                    >
                                        <i className="bi bi-arrow-right-short"></i>
                                    </span>
                                ) : (
                                    <a
                                        href="#"
                                        className={styles["nav-btn"]}
                                        aria-label="Next page"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setCurrentPage(currentPage + 1);
                                            scrollToTop();
                                        }}
                                    >
                                        <i className="bi bi-arrow-right-short"></i>
                                    </a>
                                )}
                            </li>
                        </ul>
                    </nav>
                </div>
            </section>
        </React.Fragment>
    );
};

export default ResultsPagination;